import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import * as api from "api"
import RatioElement from "common/ElementRatio"
import ResponsiveModelImage from "common/ResponsiveModelImage"
import Slider from "common/Slider"
import { memo } from "react"
import "swiper/css/bundle"
import Shared from "theme/shared"

const Styled = {
  Wrapper: styled.div`
    text-align: center;
    margin: 75px 0;
  `,
  Header: styled(Shared.Header)`
    margin-bottom: 32px;
  `,
  Title: styled(Typography)`
    font-size: 18px;
    font-weight: bold;
    color: ${(p) => p.theme.colors.duskBlue};
  `,
  Description: styled(Typography)`
    margin-top: 10px;
    font-size: 16px;
    color: ${(p) => p.theme.colors.bluishGrey};
  `,
}

type VehicleTechnologiesDesktopProps = { data: api.VehicleTechnolegy[] }

const VehicleTechnologiesDesktop = ({
  data,
}: VehicleTechnologiesDesktopProps) => (
  <Styled.Wrapper>
    <Styled.Header>ביצועים וטכנולוגיה</Styled.Header>
    <Slider
      prefix="technology"
      data={data}
      slidesPerView={3}
      spaceBetween={86}
      render={(item) => (
        <>
          <RatioElement ratio={1 / 1}>
            <ResponsiveModelImage image={item.image} cover imageSizes="367px" />
          </RatioElement>
          <Styled.Title> {item.name}</Styled.Title>
          <Styled.Description>{item.description}</Styled.Description>
        </>
      )}
    />
  </Styled.Wrapper>
)

export default memo(VehicleTechnologiesDesktop)
